export const ruTranslations = {
  // Navigation
  'nav.title': 'Smart Café',
  'nav.portal': 'Портал',
  'nav.table': 'Столики',
  'nav.kitchen': 'Кухня',
  'nav.admin': 'Админ',
  'nav.portalAdmin': 'Админ портала',
  'nav.orders': 'Заказы',

  // Table Screen
  'table.header.label': 'Терминал заказов',
  'table.header.title': 'Столик 1 - Меню',
  'table.header.items': 'позиция(й) в корзине',

  'table.sidebar.categories': 'Категории',
  'table.sidebar.system': 'Статус системы',
  'table.sidebar.terminal': 'Терминал',
  'table.sidebar.server': 'Сервер',
  'table.sidebar.online': 'В сети',
  'table.sidebar.stable': 'Стабильно',

  'table.main.menu': 'Меню',
  'table.main.featured': 'Популярные блюда',
  'table.main.items': 'позиций',
  'table.main.addOrder': 'Добавить в заказ',
  'table.main.dishPreview': 'Изображение блюда',
  'table.main.categoryAll': 'Все',

  'table.main.category.breakfast': 'Завтрак',
  'table.main.category.dessert': 'Десерты', 
  'table.main.category.drinks': 'Напитки',
  'table.main.category.lunch': 'Обед',

  'table.aside.summary': 'Сводка заказа',
  'table.aside.empty': 'Корзина пуста',
  'table.aside.selectItems': 'Выберите позиции из меню',
  'table.aside.items': 'Позиции',
  'table.aside.total': 'Итого',
  'table.aside.create': 'Создать заказ',
  'table.aside.confirm': 'Подтвердить заказ',
  'table.confirm.title': 'Ваш заказ',
  'table.confirm.ok': 'ОК',
  'table.confirm.edit': 'Редактировать',
  'table.confirm.delete': 'Удалить',
  'table.aside.callWaiter': 'Вызов официанта',
  'table.aside.waiterCalled': 'Официант уже вызван',
  'table.aside.lastOrder': 'Последний заказ',
  'table.aside.currentOrder': 'Текущий заказ',
  'table.aside.orderNumber': 'Заказ',
  'table.main.inCart': 'В корзине',

  'table.voice.title': 'Голосовой помощник',
  'table.voice.status': 'Статус',
  'table.voice.listening': '🎤 Слушаю',
  'table.voice.ready': '✓ Готов',
  'table.voice.lastCommand': 'Последняя команда',
  'table.voice.awaiting': 'Ожидание голосовой команды',
  'table.voice.feedback': 'Обратная связь',
  'table.voice.transcript': 'Транскрипт',
  'table.voice.none': '(нет)',
  'table.voice.examples': 'Попробуйте сказать:',
  'table.voice.example1': 'показать напитки',
  'table.voice.example2': 'добавить латте',
  'table.voice.example3': 'очистить корзину',
  'table.voice.example4': 'создать заказ',
  'table.voice.button': 'Привет Люме',
  'table.voice.unsupported': 'Распознавание голоса не поддерживается в этом браузере',

  // Kitchen Screen
  'kitchen.header.label': 'Кухонная станция',
  'kitchen.header.title': 'Очередь заказов',
  'kitchen.header.active': 'активно',

  'kitchen.filter.all': 'Все заказы',
  'kitchen.empty.ready': '🍳',
  'kitchen.empty.message': 'Нет заказов в очереди',
  'kitchen.empty.subtext': 'Готов к обслуживанию',

  'kitchen.order.label': 'Заказ',
  'kitchen.order.items': 'позиция',
  'kitchen.order.table': 'Столик',
  'kitchen.order.total': 'Итого',
  'kitchen.order.items.label': 'Позиции:',
  'kitchen.order.markAs': 'Отметить как',
  'kitchen.timer.label': 'Таймер подачи',
  'kitchen.timer.ready': 'Готово',
  'kitchen.timer.min': 'мин',
  'kitchen.timer.cancel': 'Сбросить',
  'table.timer.ready': 'Скоро подадим',

  // Admin Screen
  'admin.header.label': 'Панель администратора',
  'admin.header.title': 'Сводка заказов',
  'admin.header.totalLabel': 'всего',
  'admin.loginJournal.currentUser': 'Вошёл',
  'admin.loginJournal.eyebrow': 'Журнал входов',
  'admin.loginJournal.title': 'Журнал входов',
  'admin.loginJournal.refresh': 'Обновить',
  'admin.loginJournal.clear': 'Очистить список',
  'admin.loginJournal.clearing': 'Очистка...',
  'admin.loginJournal.loadError': 'Не удалось загрузить журнал входов.',
  'admin.loginJournal.clearError': 'Не удалось очистить журнал входов.',
  'admin.loginJournal.empty': 'Записей входа пока нет.',
  'admin.loginJournal.time': 'Время',
  'admin.loginJournal.fullName': 'ФИО',
  'admin.loginJournal.role': 'Роль',
  'admin.loginJournal.loginType': 'Способ входа',
  'admin.loginJournal.accessKey': 'Ключ / ID',
  'admin.loginJournal.device': 'Устройство / источник',
  'admin.loginJournal.typeManual': 'Имя пользователя и пароль',
  'admin.loginJournal.typeInitialSetup': 'Первичная настройка',
  'admin.loginJournal.typeQr': 'QR-код',
  'admin.loginJournal.typeLogout': 'Выход',
  'admin.loginJournal.roleAdmin': 'Администратор',
  'admin.loginJournal.roleKitchen': 'Кухня',
  'admin.loginJournal.roleStaff': 'Персонал',
  'admin.loginJournal.roleGuest': 'Гость',
  'admin.access.eyebrow': 'Доступ в приложение',
  'admin.access.title': 'Настройка доступа в приложение',
  'admin.access.description': 'Добавьте сотрудников, которые будут пользоваться приложением. Каждый сотрудник входит по своему имени пользователя и паролю.',
  'admin.access.adminSection': 'Ваш доступ администратора',
  'admin.access.currentKey': 'Имя пользователя',
  'admin.access.username': 'Имя пользователя',
  'admin.access.newPassword': 'Новый пароль',
  'admin.access.repeatPassword': 'Повторите пароль',
  'admin.access.newRecoveryCode': 'Введите дату рождения своей матери',
  'admin.access.repeatRecoveryCode': 'Повторите дату рождения своей матери',
  'admin.access.usersTitle': 'Пользователи приложения',
  'admin.access.addUser': 'Добавить пользователя',
  'admin.access.fullName': 'ФИО',
  'admin.access.password': 'Пароль',
  'admin.access.role': 'Роль',
  'admin.access.roleAdmin': 'Администратор',
  'admin.access.roleKitchen': 'Кухня',
  'admin.access.roleStaff': 'Персонал',
  'admin.access.delete': 'Удалить',
  'admin.access.save': 'Сохранить',
  'admin.access.saving': 'Сохранение...',
  'admin.access.passwordMismatch': 'Пароли не совпадают',
  'admin.access.recoveryCodeMismatch': 'Идентификационные коды не совпадают',
  'admin.access.duplicateKey': 'Пользователь с таким именем уже существует',
  'admin.access.reservedUsername': 'Это имя пользователя зарезервировано системой.',
  'admin.access.saved': 'Доступ сохранён',
  'admin.access.cannotDeleteLastAdmin': 'Нельзя удалить последнего администратора',
  'admin.access.cannotDeleteCurrentUser': 'Нельзя удалить текущего пользователя',
  'admin.access.loading': 'Загрузка настроек доступа...',
  'admin.access.loadError': 'Не удалось загрузить настройки доступа.',
  'admin.access.saveError': 'Не удалось сохранить настройки доступа.',
  'admin.access.addUserError': 'Не удалось добавить пользователя',
  'admin.access.requiredError': 'Заполните ФИО, имя пользователя, пароль и роль.',
  'admin.access.adminRequiredError': 'Укажите имя пользователя администратора.',
  'admin.access.startWorkday': 'Закрыть и начать рабочий день',
  'admin.access.empty': 'Пользователи доступа пока не добавлены.',
  'admin.appSettings.eyebrow': 'Параметры приложения',
  'admin.appSettings.title': 'Настройки приложения',
  'admin.appSettings.description': 'Укажите данные заведения и используйте локальные ссылки для подключения кухни и персонала к этому компьютеру.',
  'admin.appSettings.venueName': 'Название заведения',
  'admin.appSettings.venueDescription': 'Описание',
  'admin.appSettings.venueDescriptionHint': 'Короткое описание для мобильной версии',
  'admin.appSettings.venueOpeningHours': 'Часы работы по дням недели',
  'admin.appSettings.venuePhone': 'Телефон заведения',
  'admin.appSettings.venueAddress': 'Адрес заведения',
  'admin.appSettings.venuePostalCode': 'Индекс',
  'admin.appSettings.venueLocation': 'Геолокация заведения',
  'admin.appSettings.venueLocationHint': 'Подтвердите точку заведения для отображения на портале.',
  'admin.appSettings.venueLocationConfirm': 'Подтвердить геолокацию',
  'admin.appSettings.venueLocationSaving': 'Определяем...',
  'admin.appSettings.venueLocationSaved': 'Геолокация заведения сохранена для портала.',
  'admin.appSettings.venueLocationDenied': 'Доступ к геолокации запрещён. Разрешите доступ и повторите.',
  'admin.appSettings.venueLocationError': 'Не удалось сохранить геолокацию заведения.',
  'admin.appSettings.venueLocationPrivacyHint': 'Если не работает: Системные настройки → Конфиденциальность и безопасность → Службы геолокации → разрешите доступ для приложения.',
  'admin.appSettings.monday': 'Понедельник',
  'admin.appSettings.tuesday': 'Вторник',
  'admin.appSettings.wednesday': 'Среда',
  'admin.appSettings.thursday': 'Четверг',
  'admin.appSettings.friday': 'Пятница',
  'admin.appSettings.saturday': 'Суббота',
  'admin.appSettings.sunday': 'Воскресенье',
  'admin.appSettings.dayWorking': 'Работаем',
  'admin.appSettings.dayOff': 'Выходной',
  'admin.appSettings.dayOffNote': 'В этот день закрыто',
  'admin.appSettings.kitchenUrl': 'URL для входа компьютера кухни',
  'admin.appSettings.staffUrl': 'URL для входа компьютера персонала',
  'admin.appSettings.copy': 'Скопировать',
  'admin.appSettings.linkCopied': 'Ссылка скопирована',
  'admin.appSettings.save': 'Сохранить настройки',
  'admin.appSettings.saving': 'Сохранение...',
  'admin.appSettings.saved': 'Настройки сохранены',
  'admin.appSettings.requiredVenueName': 'Введите название заведения',
  'admin.appSettings.invalidVenuePhone': 'Введите корректный телефон заведения с кодом страны',
  'admin.appSettings.invalidVenueEmail': 'Введите корректный email заведения',
  'admin.appSettings.networkHint': 'Все устройства должны быть подключены к одной Wi‑Fi сети. Интернет не требуется, но главный компьютер должен быть включён.',
  'admin.appSettings.localOnly': 'Работает без интернета внутри локальной сети',
  'admin.appSettings.loading': 'Загрузка настроек приложения...',
  'admin.appSettings.loadError': 'Не удалось загрузить настройки приложения.',
  'admin.appSettings.saveError': 'Не удалось сохранить настройки приложения.',
  'admin.appSettings.completeProfileFirst': 'Сначала заполните профиль заведения (название, телефон, e-mail) и сохраните его — после этого можно скрывать цены на витрине.',
  'admin.backups.eyebrow': 'Резервные копии базы',
  'admin.backups.title': 'Бэкап и восстановление',
  'admin.backups.body': 'Создавайте локальные резервные копии базы и при необходимости восстанавливайте приложение из доступного снимка. Для восстановления потребуется пароль администратора.',
  'admin.backups.loading': 'Загрузка резервных копий...',
  'admin.backups.create': 'Создать копию сейчас',
  'admin.backups.creating': 'Создаём копию...',
  'admin.backups.refresh': 'Обновить',
  'admin.backups.latest': 'Последняя созданная копия',
  'admin.backups.emptyWindow': 'Копии пока нет',
  'admin.backups.restore': 'Восстановить',
  'admin.backups.restoreTitle': 'Подтвердите восстановление',
  'admin.backups.restoreBody': 'Для переустановки приложения из выбранной резервной копии введите пароль текущего администратора. Текущая база будет заменена, а перед этим система автоматически создаст защитную копию.',
  'admin.backups.passwordPlaceholder': 'Введите пароль администратора',
  'admin.backups.confirmRestore': 'Подтвердить восстановление',
  'admin.backups.cancelRestore': 'Отмена',
  'admin.backups.restoring': 'Восстанавливаем...',
  'admin.backups.windowHour': 'За 1 час',
  'admin.backups.windowDay': 'За 1 день',
  'admin.backups.windowWeek': 'За 1 неделю',
  'admin.backups.windowMonth': 'За 1 месяц',
  'admin.backups.loadError': 'Не удалось загрузить резервные копии.',
  'admin.backups.createError': 'Не удалось создать резервную копию.',
  'admin.backups.restoreError': 'Не удалось восстановить базу из резервной копии.',
  'admin.backups.createSuccess': 'Резервная копия создана.',
  'admin.backups.restoreSuccess': 'База восстановлена из резервной копии.',
  'admin.backups.autoHint': 'Автобэкапы по умолчанию выключены. При включении приложение будет автоматически поддерживать 4 резервные копии: за 1 час, 1 день, 1 неделю и 1 месяц.',
  'admin.backups.autoEnabled': 'Автобэкапы: вкл',
  'admin.backups.autoDisabled': 'Автобэкапы: выкл',
  'admin.backups.autoSaving': 'Сохраняем...',
  'admin.backups.autoEnableSuccess': 'Автоматические бэкапы включены.',
  'admin.backups.autoDisableSuccess': 'Автоматические бэкапы выключены.',
  'admin.backups.autoToggleError': 'Не удалось изменить режим автоматических бэкапов.',

  'admin.empty.message': 'Нет заказов. Ожидание первого заказа со столика.',

  'admin.stats.title': 'Статистика',
  'admin.stats.totalOrders': 'Всего заказов',
  'admin.stats.totalRevenue': 'Оплаченный доход',
  'admin.stats.pendingPayments': 'Ожидающие платежей',

  'admin.breakdown.title': 'Распределение по статусам',

  'admin.orders.title': 'Все заказы',
  'admin.orders.empty': 'Нет заказов.',
  'admin.orders.tableLabel': 'Столик',
  'admin.orders.markServed': 'Отметить как подано',
  'admin.orders.markPaid': 'Отметить как оплачено',
  'admin.orders.markCancelled': 'Отметить как отменено',
  'admin.orders.waiterCall': 'Вызов официанта',
  'admin.orders.itemSingular': 'позиция',
  'admin.orders.itemsPlural': 'позиций',
  'admin.orders.timeLabel': 'Время',

  // Admin Menu Management
  'admin.menu.title': 'Управление меню',
  'admin.menu.addItem': 'Добавить блюдо',
  'admin.menu.editItem': 'Редактировать блюдо',
  'admin.menu.name': 'Название',
  'admin.menu.category': 'Категория',
  'admin.menu.selectCategory': 'Выберите категорию',
  'admin.menu.price': 'Цена',
  'admin.menu.image': 'URL изображения',
  'admin.menu.description': 'Описание',
  'admin.menu.available': 'Показывать блюдо в меню и витрине',
  'admin.menu.active': 'Активно',
  'admin.menu.inactive': 'Скрыто',
  'admin.menu.save': 'Сохранить',
  'admin.menu.create': 'Создать',
  'admin.menu.cancel': 'Отмена',
  'admin.menu.empty': 'Меню пока пустое.',
  'admin.menu.edit': 'Редактировать',
  'admin.menu.delete': 'Удалить',
  'admin.menu.continue': 'Продолжить',

  'admin.tables.title': 'Управление столиками',
  'admin.tables.add': 'Добавить столик',
  'admin.tables.panelTitle': 'Добавить столик',
  'admin.tables.completedTitle': 'Настройка завершена',
  'admin.tables.completedBadge': 'Готово',
  'admin.tables.completedDescription': 'Скопируйте ссылку столика и откройте её на нужном мониторе, затем установите страницу как приложение.\n\nВы также можете скачать QR-коды и разместить их на столах — посетители смогут открыть электронное меню и сделать заказ со своего телефона.\n\nПеред запуском проверьте, что все устройства подключены к одной локальной сети кафе.',
  'admin.tables.close': 'Закрыть',
  'admin.tables.continue': 'Продолжить',
  'admin.tables.edit': 'Редактировать столик',
  'admin.tables.name': 'Название',
  'admin.tables.accessCode': 'Код доступа',
  'admin.tables.pin': 'PIN',
  'admin.tables.status': 'Статус',
  'admin.tables.capacity': 'Вместимость',
  'admin.tables.note': 'Заметка',
  'admin.tables.active': 'Активен',
  'admin.tables.inactive': 'Неактивен',
  'admin.tables.id': 'ID',
  'admin.tables.save': 'Сохранить',
  'admin.tables.create': 'Создать',
  'admin.tables.cancel': 'Отмена',
  'admin.tables.delete': 'Удалить',
  'admin.tables.activate': 'Активировать',
  'admin.tables.deactivate': 'Деактивировать',
  'admin.tables.empty': 'Столики пока не настроены.',
  'admin.tables.deleteConfirm': 'Удалить этот столик?',
  'admin.tables.deleteWithOrdersConfirm': 'Закрыть связанные заказы и удалить стол?',
  'admin.tables.lanEyebrow': 'Локальная сеть заведения',
  'admin.tables.lanBody': 'Этот адрес используется гостевыми телефонами внутри Wi‑Fi заведения без интернета.',
  'admin.tables.lanUnavailable': 'Локальный LAN-адрес пока не определён. Локальный backend продолжает работать, но для QR-ссылок нужен доступный адрес внутри сети.',
  'admin.tables.guestLanTitle': 'LAN-гостевая ссылка',
  'admin.tables.copyLanLink': 'Копировать ссылку',
  'admin.tables.openLanLink': 'Открыть столик',
  'admin.tables.copied': 'Скопировано',
  'admin.tables.qrPreview': 'QR столика',
  'admin.tables.qrCaption': 'Покажите QR на экране администратора или используйте ссылку ниже на телефоне в той же Wi‑Fi сети.',
  'admin.tables.downloadQr': 'Скачать QR',
  'admin.tables.printCard': 'Печать карточки',
  'admin.tables.printInstruction': 'Отсканируйте QR-код, чтобы открыть меню',
  'admin.tables.printWifiHint': 'Подключитесь к Wi-Fi заведения и отсканируйте QR-код, чтобы открыть меню',
  'admin.tables.printPinLabel': 'PIN для входа',

  'admin.storefront.eyebrow': 'Витрина заведения',
  'admin.storefront.title': 'Фото входа, интерьер и пассивный экран витрины',
  'admin.storefront.body': 'Сначала настраивается витрина заведения: входная фотография, интерьер и ротация активных блюд без кнопок заказа.',
  'admin.storefront.open': 'Открыть витрину',
  'admin.storefront.monitorUrl': 'URL для монитора витрины',
  'admin.storefront.showPrices': 'Показывать цены на блюдах',
  'admin.storefront.showPricesHint': 'Если включить, цена будет показываться только на карточках блюд витрины.',
  'admin.storefront.pricesOn': 'Цены включены',
  'admin.storefront.pricesOff': 'Цены скрыты',
  'admin.storefront.photoFile': 'Фото заведения',
  'admin.storefront.photoType': 'Тип фото',
  'admin.storefront.photoSort': 'Порядок',
  'admin.storefront.upload': 'Загрузить фото',
  'admin.storefront.note': 'Нужна 1 входная фотография и любое количество интерьерных. Вертикальные кадры автоматически адаптируются для горизонтального экрана.',
  'admin.storefront.portalEntranceNote': 'На портал уходит только фото типа «Вход». Интерьер, витрина и изображения блюд остаются локально.',
  'admin.storefront.portalEntranceBadge': 'Фото для портала',
  'admin.storefront.typeEntrance': 'Вход',
  'admin.storefront.typeInterior': 'Интерьер',
  'admin.storefront.entranceExists': 'Фото входа уже добавлено — интерьерных фото можно загрузить сколько угодно.',
  'admin.storefront.orderLabel': 'Порядок:',
  'admin.storefront.remove': 'Удалить',
  'admin.storefront.empty': 'Фотографии витрины пока не загружены.',
  'admin.storefront.continue': 'Продолжить',
  'admin.storefront.photoRequired': 'Сначала выберите изображение для витрины.',
  'admin.storefront.uploadError': 'Не удалось загрузить фотографию витрины.',

  // Order Statuses
  'status.new': 'Новый заказ',
  'status.inProgress': 'В работе',
  'status.ready': 'Готов к подаче',
  'status.served': 'Подано',
  'status.paid': 'Оплачено',
  'status.cancelled': 'Отменено',

  // Payment Statuses
  'payment.pending': 'Ожидание оплаты',
  'payment.paid': 'Оплачено',
  'payment.failed': 'Ошибка оплаты',
  'payment.cancelled': 'Оплата не требуется',

  'table.header.menuSuffix': 'Меню',
  'table.header.accessCode': 'Доступ',
  'table.header.inactive': 'Этот экран столика неактивен.',
  'table.header.unassigned': 'Этот экран столика еще не настроен.',
  'table.access.label': 'Доступ к столику',
  'table.access.openingTable': 'Вы открываете стол заказов',
  'table.access.titleFallback': 'Экран столика',
  'table.access.loading': 'Загрузка доступа к столику...',
  'table.access.slug': 'URL столика',
  'table.access.prompt': 'Введите PIN-код, чтобы открыть экран заказов этого столика.',
  'table.access.pinLabel': 'PIN / Пароль',
  'table.access.unlock': 'Открыть столик',
  'table.access.unlocking': 'Проверка...',
  'table.access.pinInvalid': 'Неверный PIN',
  'table.access.missingSlug': 'Откройте URL конкретного столика, например /table/t1, чтобы использовать этот экран.',
  'table.access.keypadHint': 'PIN-панель работает и мышкой, и касанием.',
  'table.access.clear': 'Очистить',
  'table.access.deviceTitle': 'Сенсорный доступ',
  'table.access.deviceBody': 'Экран рассчитан на планшеты и мониторы у столиков: крупные элементы и легкая kiosk-модель входа.',
  'table.access.rememberTitle': 'Запоминается на устройстве',
  'table.access.rememberBody': 'После успешного входа устройство останется авторизованным, пока PIN столика не изменится или доступ не будет сброшен.',
  'table.intro.eyebrow': 'Гостевой экран столика',
  'table.intro.body': 'Перед интерактивным меню гость видит спокойную вступительную сцену столика с фотографиями заведения и активными блюдами дня.',
  'table.intro.openMenu': 'Открыть меню',
  'table.intro.startOrder': 'Начать заказ',
  'table.intro.entranceKicker': 'Вход в заведение',
  'table.intro.interiorKicker': 'Интерьер',
  'table.intro.entranceTitle': 'Добро пожаловать в заведение',
  'table.intro.interiorTitle': 'Атмосфера внутри',
  'table.intro.entranceBody': 'Первый экран знакомит гостя с местом и мягко подводит к просмотру меню на этом столике.',
  'table.intro.interiorBody': 'Интерьерные кадры поддерживают сцену ожидания до перехода в интерактивный заказ.',
  'table.intro.entranceBadge': 'Вход',
  'table.intro.interiorBadge': 'Интерьер',
  'table.intro.photoPlaceholder': 'На этом экране будут показываться фотографии заведения и активные позиции меню.',
  'table.intro.dishKicker': 'Активное блюдо',
  'table.intro.dishBadge': 'Сегодня в меню',
  'table.intro.dishBody': 'В table intro участвуют только активные блюда. Они же затем доступны для заказа в интерактивном меню.',
  'table.intro.welcome': 'Добро пожаловать',
  'table.intro.todayMenu': 'Сегодня в меню',
  'table.intro.rotationNote': 'автосмена слайдов',
  'table.intro.emptyKicker': 'Старт столика',
  'table.intro.emptyTitle': 'Экран столика готов к меню',
  'table.intro.emptyBody': 'Когда будут добавлены фотографии заведения и активные блюда, они начнут участвовать во вступительной ротации этого столика.',
  'table.intro.emptyBadge': 'Ожидание',
  'table.intro.highlightOne': 'Экран сначала показывает заведение, а уже потом переводит гостя в меню.',
  'table.intro.highlightTwo': 'Вертикальные кадры сохраняют пропорции и дополняются мягким размытым фоном.',
  'table.intro.highlightThree': 'В интро и меню участвуют только активные блюда дня.',
  'table.intro.highlightFour': 'Ссылка столика сохраняется на всём пути: QR ведёт сразу в нужный контекст.',
  'table.waiter.label': 'Рабочее место официанта',
  'table.waiter.title': 'Столы в работе',
  'table.waiter.activeTable': 'Выбранный столик',
  'table.waiter.loadingTables': 'Загружаем столики...',
  'table.waiter.markServed': 'Отметить, что заказ подан',
  'table.waiter.markPaid': 'Отметить, что заказ оплачен',
  'table.waiter.markCancelled': 'Отменить заказ',
  'table.waiter.resolveCall': 'Снять вызов официанта',
  'table.waiter.noTables': 'Столики ещё не созданы. Добавьте их в админке.',
  'table.waiter.noActiveTables': 'Сейчас нет активных столиков. Активируйте хотя бы один столик в админке.',
  'storefront.display.configure': 'Настроить показ',
  'storefront.display.addEffects': 'Добавить эффекты',
  'storefront.display.dishesPerScreen': 'Блюд на одном экране',
  'storefront.display.save': 'Сохранить',
  'storefront.display.effectNone': 'Без эффекта',
  'storefront.display.effectFade': 'Плавное появление',
  'storefront.display.effectSlide': 'Сдвиг',
  'storefront.display.effectZoom': 'Мягкое увеличение',
  'storefront.display.effectRandom': 'Случайные эффекты',
  'storefront.display.settingsSaved': 'Настройки сохранены',
  'storefront.display.saveError': 'Не удалось сохранить настройки',
  'storefront.display.minimumTwo': 'Значение должно быть не меньше 2',
  'storefront.display.close': 'Закрыть',
  'storefront.display.loading': 'Загрузка витрины...',
  'storefront.display.loadErrorTitle': 'Ошибка загрузки',
  'storefront.display.loadErrorBody': 'Не удалось загрузить данные. Проверьте настройки приложения.',
  'storefront.display.emptyTitle': 'Витрина пуста',
  'storefront.display.emptyBody': 'Добавьте фотографии заведения или блюда в панели администратора.',
  'storefront.display.retry': 'Попробовать снова',
  'storefront.eyebrow': 'Локальная витрина',
  'storefront.title': 'Пассивный экран заведения до режима столиков',
  'storefront.body': 'Этот экран показывает вход, интерьер и активные блюда на внешнем мониторе. Он работает в цикле, без заказа и без перехода к гостевому сценарию.',
  'storefront.backToEditor': 'Назад к редактированию',
  'storefront.info.photos': 'Сначала показываются вход и интерьер заведения.',
  'storefront.info.menu': 'Далее в цикл входят только активные блюда.',
  'storefront.info.passive': 'Экран полностью витринный и не ждёт действий гостя.',
  'storefront.info.local': 'Контент хранится локально и готов для автономной работы.',
  'storefront.photo.entranceKicker': 'Вход',
  'storefront.photo.interiorKicker': 'Интерьер',
  'storefront.photo.entranceTitle': 'Вход в заведение',
  'storefront.photo.interiorTitle': 'Интерьер заведения',
  'storefront.photo.entranceBody': 'Первый экран знакомит гостя с точкой входа и атмосферой места.',
  'storefront.photo.interiorBody': 'Следующий кадр поддерживает ощущение пространства и внутренней сцены заведения.',
  'storefront.photo.entranceBadge': 'Фото входа',
  'storefront.photo.interiorBadge': 'Фото интерьера',
  'storefront.photo.placeholder': 'Загрузите вертикальные фотографии заведения, чтобы открыть storefront-режим.',
  'storefront.dishKicker': 'Активное блюдо',
  'storefront.dishBadge': 'Меню сегодня',
  'storefront.dishEyebrow': 'Позиция в ротации',
  'storefront.dishBody': 'Активное блюдо участвует в витринной ротации и остаётся доступным для интерактивного меню столиков.',
  'storefront.dishPlaceholder': 'У этого блюда пока нет фотографии. На витрине можно показать карточку блюда без искажений экрана.',
  'storefront.emptyKicker': 'Настройка витрины',
  'storefront.emptyTitle': 'Добавьте входное фото и активные блюда',
  'storefront.emptyBody': 'После первой настройки витрина начнёт циклически показывать фотографии заведения и активные позиции меню.',
  'storefront.emptyBadge': 'Пусто',

  // Portal
  'portal.kicker': 'Пространственный портал',
  'portal.headline': 'Войдите в живую карту будущих venue-точек',
  'portal.guidance.first': 'Перед вами реальная система venue: скачайте пакет, установите оболочку, откройте админ-портал или сразу войдите в выбранную точку.',
  'portal.guidance.returning': 'Земля помнит последнюю venue-точку. Дайте камере мягко вернуться к ней и продолжайте вход или исследование других городов.',
  'portal.memory.label': 'Память о месте',
  'portal.memory.first': 'Выберите venue один раз, и входной экран запомнит, куда нужно вернуть пользователя в следующий визит.',
  'portal.memory.returning': 'Последняя venue-точка сохранена на этом устройстве, поэтому портал может вернуть пользователя назад, не теряя глобальный обзор.',
  'portal.loading.label': 'Калибровка Земли',
  'portal.loading.body': 'Подготавливаем живую карту, данные заведений и слои навигации.',
  'portal.scale.global': 'Орбита',
  'portal.scale.country': 'Страна',
  'portal.scale.city': 'Город',
  'portal.scale.district': 'Район',
  'portal.scale.venue': 'Venue',
  'portal.interaction': 'Поворачивайте планету жестом, приближайте pinch или колесом, нажимайте на сигналы venue',
  'portal.timeline.download': 'Скачать',
  'portal.timeline.downloadValue': 'Получить пакет запуска',
  'portal.timeline.install': 'Установить',
  'portal.timeline.installValue': 'Подготовить kiosk-оболочку',
  'portal.timeline.enter': 'Войти',
  'portal.timeline.enterValue': 'Выбрать venue',
  'portal.editorial.title': 'Модули цифровой газеты',
  'portal.selectedVenue': 'Выбранное заведение',
  'portal.district': 'Район',
  'portal.street': 'Улица',
  'portal.status.live': 'Live',
  'portal.status.preview': 'Preview',
  'portal.status.offline': 'Offline',
  'portal.actions.download': 'Скачать для Windows',
  'portal.actions.install': 'Показать установку',
  'portal.actions.admin': 'Открыть админ-портал',
  'portal.actions.enter': 'Открыть заведение',
  'portal.actions.unavailable': 'Заведение недоступно',
  'portal.install.label': 'Путь установки',
  'portal.install.body': 'Реальный запуск venue начинается с устройства, локальной оболочки и маршрута портала, которому персонал может доверять сразу.',
  'portal.controls.enableLocation': "Включить геолокацию",
  'portal.controls.locationGuide': "Как включить",
  'portal.share.title': "HELFER — карта кафе и ресторанов",
  'portal.install.downloadStarted': "Загрузка началась…",
  'portal.install.downloadHint': "Загрузка началась — файл появится в папке «Загрузки». Установщик большой (~150 МБ), это займёт немного времени.",
  'portal.install.step1Title': '1. Скачать',
  'portal.install.step1Body': 'Передайте пакет запуска владельцу площадки или команде установки.',
  'portal.install.step2Title': '2. Установить',
  'portal.install.step2Body': 'Откройте shell или browser wrapper на целевом экране и закрепите staging URL.',
  'portal.install.step3Title': '3. Войти',
  'portal.install.step3Body': 'Используйте запомненный маршрут venue и PIN-вход, чтобы перейти к реальному table-flow.',
  'portal.cards.local.kicker': 'Local First',
  'portal.cards.local.title': 'Сначала вход в venue, потом дашборд',
  'portal.cards.local.body': 'Первый экран должен ориентировать гостей, операторов и инсталляторов вокруг реального места, а не вокруг абстрактной панели.',
  'portal.cards.future.kicker': 'Future Module',
  'portal.cards.future.title': 'Установка, админ-портал и live-вход остаются на расстоянии одного жеста',
  'portal.cards.future.body': 'Практические действия всегда видимы, поэтому иммерсия усиливает использование системы, а не мешает ему.',
  'portal.cards.story.kicker': 'Editorial',
  'portal.cards.story.title': 'Главная страница цифровой газеты для сети venue',
  'portal.cards.story.body': 'Короткие концептуальные блоки объясняют развитие системы, не вытесняя пространственную карту из центра внимания.',
  'portal.cards.assistant.kicker': 'Assistant',
  'portal.cards.assistant.title': 'Подсказки без шума',
  'portal.cards.assistant.body': 'Движение и текст остаются спокойными и убедительными, чтобы портал выглядел премиально на телефонах, планшетах и настенных экранах.',
  'portal.rotating.seeker.title': 'Найти подходящее место быстрее',
  'portal.rotating.seeker.body': 'Открывайте кафе и рестораны через живой пространственный портал.',
  'portal.rotating.owner.title': 'У вас своё заведение?',
  'portal.rotating.owner.body': 'Установите локальный инструмент продвижения и появитесь внутри живого портала.',
  'portal.business.hero.eyebrow': 'ЖИВОЙ ПОРТАЛ',
  'portal.business.hero.title': 'Живой портал ищет новые кафе и рестораны',
  'portal.business.hero.body': 'Подключитесь бесплатно, найдите свою точку в системе и запустите рабочее ПО для локального режима, рекламы и присутствия внутри портала.',
  'portal.business.hero.primary': 'Выбрать из списка бизнесов — кафе и рестораны',
  'portal.business.hero.secondary': 'Узнать режимы подключения',
  'portal.business.hero.later': 'Позже',
  'portal.business.modes.free.label': 'Свободный вход',
  'portal.business.modes.free.title': 'Бесплатное подключение',
  'portal.business.modes.free.body': 'Локальная автономная работа бесплатна. Поддержка режима идет за счет рекламы.',
  'portal.business.modes.silent.label': 'Тихий локальный контур',
  'portal.business.modes.silent.title': 'Локальная работа без рекламы',
  'portal.business.modes.silent.body': 'Локальная работа без рекламного слоя доступна по подписке.',
  'portal.business.modes.growth.label': 'Режим роста',
  'portal.business.modes.growth.title': 'Продвижение внутри портала',
  'portal.business.modes.growth.body': 'Локальная работа без рекламы плюс усиленное присутствие внутри живого портала. Подписка.',
  'portal.business.entry.eyebrow': 'BUSINESS ENTRY',
  'portal.business.entry.title': 'Выберите тип заведения',
  'portal.business.entry.body': 'Сначала выберите категорию бизнеса. Путь установки должен оставаться доступным даже без геолокации.',
  'portal.business.entry.placeholder': 'Кафе или рестораны',
  'portal.business.entry.option.cafe': 'Кафе',
  'portal.business.entry.option.restaurant': 'Рестораны',
  'portal.business.entry.install': 'Установить приложение на это устройство',
  'portal.business.entry.locationFallback': 'Геолокация недоступна, но вход для бизнеса остаётся открыт.',
  'portal.business.platform.eyebrow': 'BUSINESS ENTRY',
  'portal.business.platform.title': 'Выбор платформы подключения',
  'portal.business.platform.windows.title': 'Windows',
  'portal.business.platform.windows.body': 'Скачать локальное приложение для Windows',
  'portal.business.platform.windows.button': 'Скачать .exe',
  'portal.business.platform.mac.title': 'Mac',
  'portal.business.platform.mac.body': 'Запустить через браузер как app-окно',
  'portal.business.platform.mac.button': 'Инструкция для Mac',
  'portal.business.platform.portal.title': 'Портал',
  'portal.business.platform.portal.body': 'Работать с привязкой к живому порталу',
  'portal.business.platform.portal.button': 'Открыть портальный режим',
  'portal.business.mac.eyebrow': 'УСТАНОВКА ЧЕРЕЗ БРАУЗЕР',
  'portal.business.mac.title': 'Установка на Mac',
  'portal.business.mac.body': 'На Mac приложение пока устанавливается через браузер как отдельное app-окно.',
  'portal.business.mac.safari.title': 'Safari',
  'portal.business.mac.safari.body': 'Откройте портал в Safari и выберите «Добавить в Dock».',
  'portal.business.mac.chrome.title': 'Chrome',
  'portal.business.mac.chrome.body': 'Откройте портал в Chrome и выберите «Install app» / «Установить приложение».',
  'portal.business.mac.footer': 'Такой режим подходит для локальной работы, тестирования и запуска на Mac без отдельного .dmg.',
  'portal.business.portal.eyebrow': 'ПОРТАЛЬНЫЙ РЕЖИМ',
  'portal.business.portal.title': 'Работа с живой привязкой к порталу',
  'portal.business.portal.body': 'Этот режим сохраняет связь с живым порталом и позволяет заведению участвовать в discovery и продвижении, не заменяя локальную работу.',
  'portal.business.openPortal': 'Открыть портал',
  'portal.business.close': 'Закрыть',
  'portal.banner.eyebrow': 'ПОРТАЛ',
  'portal.banner.message1': 'Открой портал и выбери на сегодня события',
  'portal.banner.message2': 'Бесплатно установи инструмент своего бизнеса, и тебя увидят на странице событий',
  'portal.banner.message3': 'Если ваш бизнес онлайн, установи HELFER online и пользуйся лучшими инструментами',
  'portal.brand.subtitle': 'Локальный портал',
  'portal.support.label': 'Поддержка',
  'admin.support.button': 'Поддержка',
  'portal.voice.label': 'Голосовой помощник',
  'portal.voice.listening': 'Слушаю...',
  'portal.voice.speaking': 'Говорите...',
  'portal.controls.eyebrow': 'ВХОД ДЛЯ БИЗНЕСА',
  'portal.controls.placeholder': 'Поиск по кафе и ресторанам',
  'portal.controls.option.venues': 'Кафе и рестораны',
  'portal.controls.option.online': 'HELFER для онлайн-специалистов',
  'portal.controls.find': 'Открыть карту заведений',
  'portal.controls.install': 'Установить приложение кафе',
  'portal.controls.searchSubmit': 'Найти',
  'portal.controls.searchEmpty': 'Заведения по этому запросу не найдены.',
  'portal.mobile.nav.label': 'Навигация портала',
  'portal.mobile.nav.map': 'Карта',
  'portal.mobile.nav.search': 'Поиск',
  'portal.mobile.nav.support': 'Поддержка',
  'portal.mobile.nav.install': 'Приложение',
  'portal.hero.titleMain': 'Рабочие инструменты',
  'portal.hero.titleAccent': 'для вашего бизнеса',
  'portal.hero.body': 'Открывайте события, рабочие сценарии и инструменты Helfer для кафе и ресторанов. Всё собрано в одном месте и готово к запуску без лишней настройки.',
  'portal.hero.badge': 'Новинка: живая карта заведений — реальные цены, меню и загруженность',
  'portal.hero.venuesNearby': '{n} заведений уже на карте — цены, меню и загруженность в реальном времени',
  'portal.hero.chip.menu': 'Меню с телефона',
  'portal.hero.chip.storefront': 'Витрина на улице',
  'portal.hero.chip.tools': 'Инструменты зала и кухни',
  'portal.hero.user.titleMain': 'Кафе и рестораны',
  'portal.hero.user.titleAccent': 'на живой карте',
  'portal.hero.user.body': 'Смотрите, где открыто и насколько занято прямо сейчас. Меню, отзывы и маршрут — в одном месте.',
  'portal.hero.user.chip.menu': 'Меню и цены вживую',
  'portal.hero.user.chip.occupancy': 'Загруженность сейчас',
  'portal.hero.user.chip.route': 'Маршрут до места',
  'portal.hero.business.badge': 'Добавьте своё заведение на живую карту — гости рядом увидят вас',
  'portal.controls.userEyebrow': 'НАЙТИ ЗАВЕДЕНИЕ',
  'portal.venue.close': 'Закрыть',
  'portal.venue.address': 'Адрес',
  'portal.venue.phone': 'Телефон',
  'portal.venue.hours': 'Время работы',
  'portal.venue.status': 'Статус',
  'portal.venue.open': 'Открыто',
  'portal.venue.closed': 'Сейчас закрыто',
  'portal.venue.photoSoon': 'Фото входа скоро появится',
  'portal.venue.occupancy.title': 'Загруженность в реальном времени',
  'portal.venue.occupancy.detail': 'Активных столиков с заказом: {ordered} из {active}',
  'portal.venue.occupancy.free': 'Свободно',
  'portal.venue.occupancy.moderate': 'Умеренно',
  'portal.venue.occupancy.busy': 'Заполнено',
  'portal.map.legend.title': 'Загруженность',
  'portal.map.legend.reset': 'Сбросить',
  'portal.venue.navigation': 'Навигация',
  'portal.venue.distance': 'Расстояние: {value}',
  'portal.venue.openInMaps': 'Открыть в Maps',
  'portal.venue.walking': 'Пешком',
  'portal.venue.driving': 'На машине',
  'portal.venue.minutes': '{n} мин',
  'portal.venue.showMenu': 'Посмотреть меню',
  'portal.venue.hideMenu': 'Скрыть меню',
  'portal.venue.reviews': 'Отзывы',
  'portal.venue.reviewsCount': 'Отзывы ({n})',
  'portal.venue.hideReviews': 'Скрыть отзывы',
  'portal.venue.menu': 'Меню',
  'portal.venue.itemsCount': '{n} поз.',
  'portal.venue.allCategories': 'Все',
  'portal.venue.noItems': 'В этой категории пока нет блюд.',
  'portal.venue.noReviews': 'Пока отзывов нет.',
  'portal.venue.leaveReview': 'Оставить отзыв',
  'portal.venue.reviewPlaceholder': 'Напишите короткий отзыв о заведении',
  'portal.venue.saveReview': 'Сохранить отзыв',
  'portal.venue.guestAuthor': 'Гость портала',
  'portal.venue.uncategorized': 'Без категории',
  'portal.venue.unit.m': 'м',
  'portal.venue.unit.km': 'км',
  'portal.venue.day.mon': 'Пн',
  'portal.venue.day.tue': 'Вт',
  'portal.venue.day.wed': 'Ср',
  'portal.venue.day.thu': 'Чт',
  'portal.venue.day.fri': 'Пт',
  'portal.venue.day.sat': 'Сб',
  'portal.venue.day.sun': 'Вс',
  'portal.controls.back': 'Назад',
  'portal.controls.locationDenied': 'Геолокация недоступна. Установка приложения всё равно доступна.',
  'portal.controls.locationManual': 'Геолокация недоступна. Введите город или название заведения в поиске — карта откроется по нему.',
  'portal.controls.locationSecureContext': 'Для запроса геолокации откройте портал через HTTPS или localhost.',
  'support.eyebrow': 'Поддержка',
  'support.title': 'Связаться с поддержкой',
  'support.body': 'Оставьте контакты и коротко опишите вопрос. Мы отправим обращение в поддержку.',
  'support.fullName': 'ФИО',
  'support.fullNamePlaceholder': 'Введите ФИО',
  'support.contact': 'Телефон / мессенджер',
  'support.contactPlaceholder': 'Например, +353..., Telegram @...',
  'support.message': 'Текст обращения',
  'support.messagePlaceholder': 'Опишите проблему или вопрос',
  'support.send': 'Отправить',
  'support.sending': 'Отправляем...',
  'support.cancel': 'Закрыть',
  'support.success': 'Сообщение отправлено в поддержку',
  'support.validation': 'Заполните все поля',
  'support.error': 'Не удалось отправить сообщение',
  'portal.events.sheet.eyebrow': 'КАРТА ЗАВЕДЕНИЙ',
  'portal.events.sheet.title': 'Откройте карту кафе и ресторанов',
  'portal.events.sheet.body': 'Можно продолжить прямо в браузере или установить приложение, чтобы быстрее находить заведения рядом и возвращаться к карте без лишних шагов.',
  'portal.events.sheet.mapTitle': 'Живая карта заведений',
  'portal.events.sheet.mapBody': 'Смотрите кафе и рестораны рядом, меню, отзывы, маршрут и текущую загруженность в одном месте.',
  'portal.events.sheet.ios': 'iPhone / App Store',
  'portal.events.sheet.android': 'Android / Google Play',
  'portal.install.comingSoon': 'Скоро',
  'portal.events.sheet.browser': 'Открыть в браузере',
  'portal.install.sheet.eyebrow': 'ЛОКАЛЬНАЯ УСТАНОВКА',
  'portal.install.sheet.title': 'HELFER для кафе и ресторанов',
  'portal.install.sheet.body': 'Установите локальное приложение на компьютер администратора, чтобы принимать заказы, управлять меню, видеть столики и показывать заведение на живой карте портала.',
  'portal.install.sheet.value1': 'Заказы со столиков сразу попадают администратору и на кухню',
  'portal.install.sheet.value2': 'Меню, цены и фото обновляются на портале из локального приложения',
  'portal.install.sheet.value3': 'Загруженность зала считается по статусам столиков в реальном времени',
  'portal.install.sheet.value4': 'Базовый запуск без сложной настройки и без зависимости от облака',
  'portal.install.sheet.note': 'Основная работа остаётся на устройстве заведения.',
  'portal.install.sheet.trust': 'Базовые функции бесплатны. Витрина, статистика и бэкапы подключаются отдельно, когда они действительно нужны.',
  'portal.install.windows.title': 'Windows',
  'portal.install.windows.body': 'Скачать локальное приложение для Windows',
  'portal.install.windows.button': 'Скачать для Windows',
  'portal.install.mac.title': 'Mac',
  'portal.install.mac.body': 'Скачать локальное приложение для macOS',
  'portal.install.mac.button': 'Скачать для Mac',
  'portal.install.portal.title': 'Портал',
  'portal.install.portal.body': 'Работать с привязкой к живому порталу',
  'portal.install.portal.button': 'Открыть портальный режим',
  'portal.install.mac.guide.eyebrow': 'УСТАНОВКА ЧЕРЕЗ БРАУЗЕР',
  'portal.install.mac.guide.title': 'Установка на Mac',
  'portal.install.mac.guide.body': 'На Mac приложение пока устанавливается через браузер как отдельное app-окно.',
  'portal.install.mac.guide.safari.title': 'Safari',
  'portal.install.mac.guide.safari.body': 'Откройте портал в Safari и выберите «Добавить в Dock».',
  'portal.install.mac.guide.chrome.title': 'Chrome',
  'portal.install.mac.guide.chrome.body': 'Откройте портал в Chrome и выберите «Install app» / «Установить приложение».',
  'portal.install.mac.guide.footer': 'Такой режим подходит для локальной работы, тестирования и запуска на Mac без отдельного .dmg.',
  'portal.install.portal.guide.eyebrow': 'ПОРТАЛЬНЫЙ РЕЖИМ',
  'portal.install.portal.guide.title': 'Работа с живой привязкой к порталу',
  'portal.install.portal.guide.body': 'Этот режим работает с живой привязкой к порталу и даёт заведению участие в discovery и продвижении.',
  'portal.install.online.eyebrow': 'HELFER ONLINE',
  'portal.install.online.title': 'Предлагайте свои знания и услуги в HELFER',
  'portal.install.online.body': 'Короткий вход для специалистов: создайте профиль, покажите курсы и публикации, собирайте доверие через отзывы и помогайте людям находить вас в ленте.',
  'portal.install.online.bridgeKicker': 'Для тренеров, консультантов, преподавателей и экспертов',
  'portal.install.online.bridgeText': 'За несколько секунд человек должен понять: здесь можно делиться знаниями, строить доверие и быть найденным через ленту.',
  'portal.install.online.features.title': 'Что внутри',
  'portal.install.online.feature1': 'Профиль специалиста',
  'portal.install.online.feature2': 'Курсы, услуги и полезные публикации',
  'portal.install.online.feature3': 'Отзывы и доверие на одной странице',
  'portal.install.online.feature4': 'Поиск через ленту и фильтры',
  'portal.install.online.createProfile': 'Создать профиль специалиста',
  'portal.install.online.createProfileBody': 'Зарегистрируйтесь и оформите страницу с услугами, курсами и отзывами.',
  'portal.install.online.viewFeed': 'Посмотреть ленту',
  'portal.install.online.viewFeedBody': 'Посмотрите, как выглядят публикации, курсы и предложения внутри HELFER.',
  'portal.install.online.findSpecialist': 'Найти специалиста',
  'portal.install.online.findSpecialistBody': 'Используйте фильтры, откройте аватар и изучите профиль, курсы и отзывы.',
  'portal.install.online.learnMore': 'Подробнее о HELFER',
  'portal.install.online.ios': 'iPhone / App Store',
  'portal.install.online.mac': 'Mac',
  'portal.install.online.windows': 'Windows',
  'portal.install.online.android': 'Android / Google Play',
  'portal.install.online.open': 'Открыть HELFER online',
  'portal.install.openPortal': 'Открыть портал',
  'portal.install.close': 'Закрыть',
  'desktop.entry.eyebrow': 'Локальное приложение',
  'desktop.entry.title': 'Добро пожаловать в систему управления заведением',
  'desktop.entry.body': 'Вы установили локальный инструмент для работы кафе или ресторана.',
  'desktop.entry.video.eyebrow': 'Демо-видео',
  'desktop.entry.video.placeholder': 'Короткое демо поможет быстро показать, как устроены управление, размещение и рабочий поток внутри локальной системы.',
  'desktop.entry.video.opened': 'Демо-экран открыт. Здесь можно разместить локальное обучающее видео или презентационный ролик для персонала.',
  'desktop.entry.login.eyebrow': 'Вход по ключу',
  'desktop.entry.login.title': 'Войдите в рабочую среду',
  'desktop.entry.login.body': 'Введите ключ доступа и пароль, чтобы открыть локальное приложение под своей ролью.',
  'desktop.entry.login.fieldLabel': 'Ключ доступа',
  'desktop.entry.login.placeholder': 'Например, ADMIN-LOCAL-01',
  'desktop.entry.login.submit': 'Войти',
  'desktop.entry.login.loading': 'Вход...',
  'desktop.entry.login.qrHint': 'Также можно войти, отсканировав персональный QR-код.',
  'desktop.entry.login.error': 'Не удалось выполнить вход. Проверьте ключ доступа.',
  'desktop.entry.qr.eyebrow': 'QR-вход',
  'desktop.entry.qr.title': 'Вход через персональный QR-код',
  'desktop.entry.qr.body': 'Если QR-код открывает приложение с токеном доступа, вход выполняется автоматически без отдельной формы.',
  'desktop.entry.qr.scanTitle': 'Сканируйте QR и откройте приложение',
  'desktop.entry.qr.scanBody': 'Используйте ссылку вида /login?token=... или app://login?token=..., чтобы система сразу определила пользователя и записала вход.',
  'desktop.entry.qr.detected': 'Обнаружен QR-токен',
  'desktop.start.eyebrow': 'Локальный старт',
  'desktop.start.title': 'Добро пожаловать',
  'desktop.start.body': 'Выберите следующий шаг.',
  'desktop.start.brand.subtitle': 'Кафе и ресторан',
  'desktop.start.hero.titleLineOne': 'Добро пожаловать',
  'desktop.start.hero.titleLineTwo': 'в HELFER',
  'desktop.start.hero.body': 'Локальное приложение для управления вашим кафе или рестораном: заказы, кухня, персонал и аналитика — всё в одном месте.',
  'desktop.start.hero.enterApp': 'Войти в приложение',
  'desktop.start.status.title': 'Приложение работает локально',
  'desktop.start.status.body': 'Все данные хранятся на этом устройстве',
  'desktop.start.visual.tables': 'Столики',
  'desktop.start.visual.tablesBody': 'Управление столами',
  'desktop.start.visual.orders': 'Заказы',
  'desktop.start.visual.ordersBody': 'Список заказов',
  'desktop.start.visual.kitchen': 'Кухня',
  'desktop.start.visual.kitchenBody': 'Экран кухни',
  'desktop.start.visual.staff': 'Персонал',
  'desktop.start.visual.staffBody': 'Управление персоналом',
  'desktop.start.video.eyebrow': 'Демо-экран',
  'desktop.start.video.title': 'Короткое демо',
  'desktop.start.video.placeholder': 'Здесь можно держать короткое знакомство с системой для владельца и команды.',
  'desktop.start.video.opened': 'Демо-область активна. Здесь можно быстро показать запуск, рабочие экраны и сервисный режим.',
  'desktop.start.video.note': 'Вспомогательная зона для короткого ролика или локального видео-инструктажа.',
  'desktop.start.video.play': 'Открыть демо',
  'desktop.start.login.eyebrow': 'Вход по ключу',
  'desktop.start.login.title': 'Откройте локальную систему',
  'desktop.start.login.body': 'Введите ключ доступа и пароль. QR-вход продолжает работать отдельно.',
  'desktop.start.login.firstAdminEyebrow': 'Первый вход администратора',
  'desktop.start.login.firstAdminKey': 'Ключ',
  'desktop.start.login.firstAdminPassword': 'Пароль',
  'desktop.start.login.fieldLabel': 'Ключ доступа',
  'desktop.start.login.placeholder': 'Например, ADMIN-LOCAL-01',
  'desktop.start.login.passwordLabel': 'Пароль',
  'desktop.start.login.passwordPlaceholder': 'Введите пароль первого входа',
  'desktop.start.login.submit': 'Войти',
  'desktop.start.login.loading': 'Вход...',
  'desktop.start.login.reveal': 'Открыть вход',
  'desktop.start.login.hide': 'Скрыть вход',
  'desktop.start.login.qrHint': 'Также можно войти, отсканировав персональный QR-код.',
  'desktop.start.login.error': 'Не удалось выполнить вход. Проверьте ключ доступа.',
  'desktop.start.login.invalidCredentials': 'Неверный ключ доступа или пароль',
  'desktopWelcome.brandSubtitle': 'КАФЕ И РЕСТОРАН',
  'desktopWelcome.welcomeLine1': 'Добро пожаловать',
  'desktopWelcome.welcomeLine2': 'в HELFER',
  'desktopWelcome.description': 'Локальное приложение для управления вашим кафе или рестораном: заказы, кухня, персонал и аналитика — всё в одном месте.',
  'desktopWelcome.enterApp': 'Войти в приложение',
  'desktopWelcome.localTitle': 'Приложение работает локально',
  'desktopWelcome.localSubtitle': 'Все данные хранятся на этом устройстве',
  'desktopWelcome.username': 'Имя пользователя',
  'desktopWelcome.password': 'Пароль',
  'desktopWelcome.loginEyebrow': 'ВХОД В ПРИЛОЖЕНИЕ',
  'desktopWelcome.loginTitle': 'Введите данные доступа',
  'desktopWelcome.loginSubtitle': 'Введите имя пользователя и пароль, чтобы открыть рабочее приложение.',
  'desktopWelcome.login': 'Войти',
  'desktopWelcome.forgotPassword': 'Забыли пароль?',
  'desktopWelcome.initialSetupEyebrow': 'ПЕРВИЧНАЯ НАСТРОЙКА ДОСТУПА',
  'desktopWelcome.initialSetupTitle': 'Создайте администратора',
  'desktopWelcome.initialSetupSubtitle': 'Задайте данные администратора. После этого сотрудники смогут входить в приложение по имени пользователя и паролю.',
  'desktopWelcome.adminFullName': 'ФИО администратора',
  'desktopWelcome.repeatPassword': 'Повторите пароль',
  'desktopWelcome.recoveryCode': 'Дата рождения вашей матери',
  'desktopWelcome.repeatRecoveryCode': 'Повторите дату рождения вашей матери',
  'desktopWelcome.saveAndEnter': 'Сохранить и войти',
  'desktopWelcome.recoveryTitle': 'Восстановление доступа',
  'desktopWelcome.enterIdentificationCode': 'Введите дату рождения вашей матери',
  'desktopWelcome.createNewPassword': 'Создайте новый пароль',
  'desktopWelcome.repeatNewPassword': 'Повторите новый пароль',
  'desktopWelcome.recoverAccess': 'Восстановить доступ',
  'desktopWelcome.backToSignIn': 'Вернуться ко входу',
  'desktopWelcome.recoverySuccess': 'Пароль администратора обновлён. Войдите с новым паролем.',
  'desktopWelcome.recoveryError': 'Не удалось восстановить доступ',
  'desktopWelcome.recoveryAdminOnly': 'Восстановление пароля доступно только администратору. Обратитесь к администратору приложения.',
  'desktopWelcome.supportRecoveryHint': 'Если вы забыли пароль и идентификационный код, обратитесь в поддержку HELFER.',
  'desktopWelcome.fillAllFields': 'Заполните все поля',
  'desktopWelcome.passwordsDoNotMatch': 'Пароли не совпадают',
  'desktopWelcome.identificationCodesDoNotMatch': 'Идентификационные коды не совпадают',
  'desktopWelcome.invalidCredentials': 'Неверное имя пользователя или пароль',
  'desktopWelcome.bootstrapAccessError': 'Не удалось открыть локальный админ-доступ.',
  'desktopWelcome.loginError': 'Не удалось выполнить вход.',
  'desktopWelcome.invalidRecoveryCode': 'Неверный идентификационный код',
  'desktopWelcome.recoveryCodeMissing': 'Идентификационный код восстановления не настроен. Войдите через поддержку HELFER и задайте новый пароль.',
  'desktopWelcome.userNotFound': 'Пользователь не найден',
  'desktopWelcome.saveAdministratorError': 'Не удалось сохранить администратора',
  'desktopWelcome.duplicateUsername': 'Пользователь с таким именем уже существует',
  'desktopWelcome.qrCardScanHint': 'Сканируйте телефоном в той же сети',
  'desktopWelcome.qrCardOr': 'или',
  'desktop.start.session.eyebrow': 'Текущая сессия',
  'desktop.start.session.logout': 'Сменить пользователя',
  'desktop.start.session.loginType': 'Способ входа',
  'desktop.start.session.role': 'Роль',
  'desktop.start.session.loginTime': 'Последний вход',
  'desktop.start.session.accessKey': 'Ключ доступа',
  'desktop.start.session.loginTypeManual': 'Ключ доступа',
  'desktop.start.session.loginTypeQr': 'QR-код',
  'desktop.start.session.roleAdmin': 'Администратор',
  'desktop.start.session.roleKitchen': 'Кухня',
  'desktop.start.session.roleStaff': 'Персонал',
  'desktop.start.session.roleGuest': 'Гость',
  'desktop.start.quick.eyebrow': 'Быстрый запуск',
  'desktop.start.quick.title': 'Выберите следующий шаг',
  'desktop.start.quick.body': 'Откройте нужный рабочий режим.',
  'desktop.start.quick.primaryEyebrow': 'Основной маршрут',
  'desktop.start.quick.ready': 'Локальная система готова',
  'desktop.start.quick.admin': 'Открыть админку',
  'desktop.start.quick.kitchen': 'Открыть кухню',
  'desktop.start.quick.tables': 'Открыть столы',
  'desktop.start.quick.myTable': 'Открыть мой стол',
  'desktop.start.quick.qrDemo': 'Открыть QR-демо столика',
  'desktop.start.qr.eyebrow': 'QR-доступ',
  'desktop.start.qr.title': 'Гостевой доступ',
  'desktop.start.qr.body': 'Откройте ссылку для гостевого входа в тот же локальный маршрут.',
  'desktop.start.qr.scanTitle': 'QR приводит в тот же локальный вход',
  'desktop.start.qr.scanBody': 'Гость или сотрудник может открыть приложение по ссылке с токеном.',
  'desktop.start.qr.detected': 'Обнаружен QR-токен',
  'desktop.start.qr.demoEyebrow': 'Гостевой доступ',
  'desktop.start.qr.demoTitle': 'Гостевая ссылка',
  'desktop.start.qr.openGuest': 'Открыть как гость',
  'desktop.start.qr.copyLink': 'Скопировать ссылку',
  'desktop.nav.signOut': 'Выйти',
  'desktop.nav.openPortal': 'Открыть портал',
  'desktop.nav.backToLocal': 'Назад в локальное приложение',
  'desktop.start.capability.local': 'Конфиденциальная локальная работа на компьютере заведения',
  'desktop.start.capability.offline': 'Автономный режим без обязательного интернета',
  'desktop.start.capability.menu': 'Настройка меню, витрин и экранов показа',
  'desktop.start.capability.tables': 'Инструменты обслуживания и столикового режима',
  'desktop.start.capability.admin': 'Админ-панель и контроль кухни в одном контуре',
  'desktop.start.capability.portal': 'Публичное присутствие и рекламный портал',
  'desktop.start.capability.backup': 'Готовность к резервным копиям и восстановлению',
  'desktop.start.capability.qr': 'Продолжение стола на телефоне через QR-код',

  // Update banner
  'update.available': 'Доступно обновление приложения',
  'update.download': 'Скачать обновление',

  // Venue details panel
  'venue.close': 'Закрыть',
  'venue.address': 'Адрес',
  'venue.phone': 'Телефон',
  'venue.hours': 'Время работы',
  'venue.status': 'Статус заведения',
  'venue.open': 'Открыто',
  'venue.closed': 'Сейчас закрыто',
  'venue.occupancy': 'Загруженность в реальном времени',
  'venue.occupancyDetail': 'Активных столиков с заказом: {active} из {total}',
  'venue.navigation': 'Навигация',
  'venue.distance': 'Расстояние:',
  'venue.openMaps': 'Открыть в Maps',
  'venue.walking': 'Пешком',
  'venue.driving': 'На машине',
  'venue.showMenu': 'Посмотреть меню',
  'venue.hideMenu': 'Скрыть меню',
  'venue.entrancePhotoSoon': 'Фото входа скоро появится',
  'venue.menuOnlyLocal': 'Меню доступно только для подключённого заведения.',
  'venue.menuNoConnection': 'Меню временно недоступно: нет связи с локальным приложением.',
  'venue.menuClosed': 'Заведение сейчас закрыто. Меню недоступно.',
  'venue.reviews': 'Отзывы',
  'venue.reviewAuthorPlaceholder': 'Напишите ваше имя (необязательно)',
  'venue.reviewPlaceholder': 'Напишите короткий отзыв о заведении...',
  'venue.saveReview': 'Сохранить отзыв',
  'venue.reportVenue': 'Пожаловаться',
  'venue.reportReview': 'Пожаловаться на отзыв',
  'venue.reportTitle': 'Жалоба на заведение',
  'venue.reportReviewTitle': 'Жалоба на отзыв',
  'venue.reportHelp': 'Сообщение попадёт владельцу портала для проверки.',
  'venue.reportReason': 'Причина',
  'venue.reportComment': 'Комментарий',
  'venue.reportCommentPlaceholder': 'Коротко опишите проблему',
  'venue.reportContact': 'Контакт для ответа (необязательно)',
  'venue.reportSend': 'Отправить жалобу',
  'venue.reportSending': 'Отправляем...',
  'venue.reportCancel': 'Отмена',
  'venue.reportSuccess': 'Жалоба отправлена. Спасибо, мы проверим.',
  'venue.reportError': 'Не удалось отправить жалобу',
  'venue.reportReason.wrong_location': 'Неверная локация',
  'venue.reportReason.fake_venue': 'Фейковое заведение',
  'venue.reportReason.offensive_content': 'Оскорбительный контент',
  'venue.reportReason.wrong_menu': 'Неверное меню',
  'venue.reportReason.wrong_prices': 'Неверные цены',
  'venue.reportReason.privacy': 'Персональные данные',
  'venue.reportReason.spam': 'Спам',
  'venue.reportReason.other': 'Другое',

  // Cookie consent banner
  'cookie.dialogLabel': 'Согласие на использование файлов cookie',
  'cookie.heading': 'Мы используем файлы cookie',
  'cookie.body': 'Необходимые cookies обеспечивают работу сайта. Аналитические cookies (Google Analytics) помогают улучшать сервис — мы не продаём эти данные.',
  'cookie.moreInfo': 'Подробнее',
  'cookie.privacy': 'Конфиденциальность',
  'cookie.acceptAll': 'Принять все',
  'cookie.necessaryOnly': 'Только необходимые',

  // Consent text in modals
  'consent.usingService': 'Используя сервис, вы соглашаетесь с',
  'consent.installing': 'Устанавливая приложение, вы соглашаетесь с',
  'consent.privacyPolicy': 'Политикой конфиденциальности',
  'consent.and': 'и',
  'consent.terms': 'Условиями использования',

  // Legal page navigation & common
  'legal.backToHome': 'На главную',
  'legal.edition': 'Редакция от 17 мая 2025 г. Вступает в силу с даты публикации.',
  'legal.footer': '© 2024–2025 ОО «Центр психологического и физического здоровья». HELFER — бесплатный некоммерческий проект.',
  'legal.nav.privacy': 'Конфиденциальность',
  'legal.nav.terms': 'Условия использования',
  'legal.nav.cookies': 'Файлы cookie',
  'legal.nav.geolocation': 'Геолокация',
  'legal.nav.venueRules': 'Правила заведений',
  'legal.nav.accountDeletion': 'Удаление аккаунта',
  'legal.privacy.badge': 'HELFER · ОО «ЦПФЗ»',
  'legal.privacy.title': 'Политика конфиденциальности',
  'legal.terms.badge': 'HELFER · ОО «ЦПФЗ»',
  'legal.terms.title': 'Условия использования',
  'legal.cookies.badge': 'HELFER · ОО «ЦПФЗ»',
  'legal.cookies.title': 'Политика файлов cookie и локального хранилища',
  'legal.geolocation.badge': 'HELFER · ОО «ЦПФЗ»',
  'legal.geolocation.title': 'Геолокация — зачем и как',
  'legal.geolocation.subtitle': 'Простым языком о том, как HELFER использует геоданные.',
  'legal.venueRules.badge': 'HELFER · ОО «ЦПФЗ»',
  'legal.venueRules.title': 'Правила для заведений',
  'legal.venueRules.subtitle': 'Обязательно к прочтению перед регистрацией в HELFER.',
  'portal.footer.free': 'Бесплатно для всех.',
  'portal.footer.nonProfit': 'Мы — некоммерческий проект (НКО)',

  'locationGuide.title': 'Разрешите доступ к геолокации',
  'locationGuide.body': 'Для поиска ближайших заведений порталу нужен доступ к вашему местоположению. Включите его в настройках системы.',
  'locationGuide.steps': 'Как разрешить',
  'locationGuide.mac.step1': 'Откройте Системные настройки (меню Apple → Системные настройки)',
  'locationGuide.mac.step2': 'Перейдите в «Конфиденциальность и безопасность»',
  'locationGuide.mac.step3': 'Нажмите «Геолокация»',
  'locationGuide.mac.step4': 'Найдите «Cafe Local» в списке и включите переключатель',
  'locationGuide.win.step1': 'Откройте Параметры Windows (Win + I)',
  'locationGuide.win.step2': 'Перейдите в «Конфиденциальность и безопасность»',
  'locationGuide.win.step3': 'Выберите «Местоположение»',
  'locationGuide.win.step4': 'Включите «Разрешить приложениям доступ к вашему местоположению»',
  'locationGuide.win.step5': 'Убедитесь что «Настольные приложения» тоже включены',
  'locationGuide.linux': 'Убедитесь что в настройках системы разрешена геолокация для этого приложения.',
  'locationGuide.openSettings': 'Открыть настройки системы',
  'locationGuide.opening': 'Открываем настройки…',
  'locationGuide.retry': 'Я разрешил — проверить снова',
  'locationGuide.retrying': 'Проверяем…',
  'locationGuide.skip': 'Пропустить — продолжить без геолокации',
  // Billing / subscription
  'billing.back': 'Назад в админку',
  'billing.title': 'Подписка и платежи',
  'billing.subtitleTemplate': 'Базовая работа кафе бесплатна: до {tables} столиков и {menuItems} блюд в меню. Подписка «{plan}» снимает оба ограничения — добавляйте столики и блюда без лимита.',
  'billing.success.title': 'Оплата прошла успешно 🎉',
  'billing.success.body': 'Подписка активируется в течение нескольких секунд. Чек придёт на вашу почту от Stripe.',
  'billing.canceled': 'Оплата отменена. Вы можете попробовать снова в любой момент.',
  'billing.status.title': 'Текущий статус',
  'billing.plan': 'Тариф',
  'billing.free': 'Бесплатный',
  'billing.billingCycle': 'Период оплаты',
  'billing.year': 'Год',
  'billing.month': 'Месяц',
  'billing.activeUntil': 'Действует до',
  'billing.nextCharge': 'Следующее списание',
  'billing.email': 'Почта',
  'billing.tables': 'Столики',
  'billing.menuItems': 'Блюда в меню',
  'billing.opening': 'Открываем…',
  'billing.manage': 'Управлять подпиской / отменить',
  'billing.subscribeTitle': 'Оформить подписку «{plan}»',
  'billing.cycleMonthly': 'Месяц',
  'billing.cycleYearly': 'Год · 2 месяца в подарок',
  'billing.emailLabel': 'Email для чека и доступа',
  'billing.preparing': 'Готовим оплату…',
  'billing.checkout': 'Перейти к оплате',
  'billing.unavailable': 'Оплата временно недоступна: платёжная система ещё настраивается на сервере.',
  'billing.stripeNote': 'Оплата проходит на защищённой странице Stripe. Отменить подписку можно в любой момент в кабинете Stripe.',
  'billing.history.title': 'История платежей',
  'billing.history.empty': 'Пока нет ни одной оплаты.',
  'billing.history.date': 'Дата',
  'billing.history.plan': 'Тариф',
  'billing.history.period': 'Период',
  'billing.history.email': 'Почта',
  'billing.history.status': 'Статус',
  'billing.statusLabel.free': 'Бесплатный',
  'billing.statusLabel.active': 'Активна',
  'billing.statusLabel.trialing': 'Пробный период',
  'billing.statusLabel.past_due': 'Ожидает оплату',
  'billing.statusLabel.unpaid': 'Не оплачена',
  'billing.statusLabel.incomplete': 'Не завершена',
  'billing.statusLabel.canceled': 'Отменена',
  'billing.checkoutStatus.paid': 'Оплачено',
  'billing.checkoutStatus.failed': 'Ошибка',
  'billing.checkoutStatus.cancelled': 'Отменено',
  'billing.checkoutStatus.pending': 'В ожидании',
  'billing.error.load': 'Не удалось загрузить статус подписки.',
  'billing.error.email': 'Укажите корректный email.',
  'billing.error.noUrl': 'Сервер не вернул ссылку на оплату.',
  'billing.error.checkout': 'Не удалось создать оплату.',
  'billing.error.portal': 'Не удалось открыть кабинет Stripe.',
  // Admin extra strings
  'admin.limit.title': 'Достигнут лимит бесплатного тарифа',
  'admin.limit.detail': 'Уже добавлено: {current} из {limit} {unit} на бесплатном тарифе.',
  'admin.limit.tablesWord': 'столиков',
  'admin.limit.dishesWord': 'блюд',
  'admin.limit.subscribe': 'Оформить подписку',
  'admin.limit.later': 'Позже',
  'admin.build': 'Сборка',
  'admin.billingButton': 'Подписка и платежи',
  'admin.today': 'Сегодня',
  'admin.ordersHint': 'На главной странице показываются заказы текущего рабочего дня. История заказов — в отдельной вкладке:',
  'admin.salesStats': 'Статистика продаж',
  'admin.staffPin.title': 'PIN-коды официантов',
  'admin.staffPin.subtitle': 'Установите 4-значный PIN для каждого официанта',
  'admin.staffPin.invalid': 'PIN должен быть 4 цифры',
  'admin.staffPin.saved': 'PIN сохранён',
  'admin.save': 'Сохранить',
  'admin.error': 'Ошибка',
  'admin.connectionError': 'Ошибка соединения',
  'admin.staffAnalytics.eyebrow': 'Аналитика',
  'admin.staffAnalytics.title': 'Аналитика официантов',
  'admin.staffAnalytics.name': 'Имя',
  'admin.staffAnalytics.orders': 'Заказов',
  'admin.staffAnalytics.tables': 'Столиков',
  'admin.staffAnalytics.lastOrder': 'Последний заказ',
  'admin.phoneHint': 'Введите номер с кодом страны, чтобы на портале по нему можно было позвонить.',
  'admin.venueEmail': 'Email заведения',
  'admin.geo.error': 'Геолокация: ошибка',
  'admin.geo.syncSkipped': 'синхронизация не настроена',
  'admin.geo.syncError': 'ошибка синхронизации',
  'admin.geo.apiError': 'API: ошибка',

  // Помощник прибыли — Ингредиенты
  'costing.ingredients.label': 'Справочник',
  'costing.ingredients.title': 'Ингредиенты',
  'costing.ingredients.add': 'Добавить ингредиент',
  'costing.ingredients.search': 'Поиск ингредиентов...',
  'costing.ingredients.allUnits': 'Все единицы',
  'costing.ingredients.empty': 'Нет ингредиентов',
  'costing.ingredients.name': 'Название',
  'costing.ingredients.unit': 'Единица',
  'costing.ingredients.packageSize': 'Размер упаковки',
  'costing.ingredients.packagePrice': 'Цена',
  'costing.ingredients.unitCost': 'Цена за единицу',
  'costing.ingredients.supplier': 'Поставщик',
  'costing.ingredients.actions': 'Действия',
  'costing.ingredients.addNew': 'Добавить ингредиент',
  'costing.ingredients.edit': 'Редактировать',
  'costing.ingredients.save': 'Сохранить',
  'costing.ingredients.saving': 'Сохранение...',
  'costing.ingredients.cancel': 'Отменить',
  'costing.ingredients.currency': 'Валюта',
  'costing.ingredients.noSupplier': 'Нет поставщика',
  'costing.ingredients.calculatedCost': 'Рассчитанная цена за единицу',
  'costing.ingredients.loadError': 'Ошибка загрузки ингредиентов',
  'costing.ingredients.saveError': 'Ошибка сохранения ингредиента',
  'costing.ingredients.deleteError': 'Ошибка удаления ингредиента',
  'costing.ingredients.confirmDelete': 'Удалить этот ингредиент?',
  'costing.ingredients.priceHistory': 'История цен',
  'costing.ingredients.noPriceHistory': 'Истории цен нет',
  'costing.ingredients.close': 'Закрыть',

  // Помощник прибыли — Рецепты
  'costing.recipes.label': 'Рецепты',
  'costing.recipes.title': 'Редактор рецептов',
  'costing.recipes.selectDish': 'Выберите блюдо',
  'costing.recipes.selectDishHint': 'Выберите блюдо для редактирования рецепта',
  'costing.recipes.ingredients': 'Ингредиенты',
  'costing.recipes.noIngredients': 'Нет ингредиентов в рецепте',
  'costing.recipes.ingredient': 'Ингредиент',
  'costing.recipes.quantity': 'Кол-во',
  'costing.recipes.unit': 'Единица',
  'costing.recipes.waste': 'Отходы %',
  'costing.recipes.unitCost': 'Цена/единица',
  'costing.recipes.lineCost': 'Стоимость строки',
  'costing.recipes.actions': 'Действия',
  'costing.recipes.selectIngredient': 'Выберите ингредиент...',
  'costing.recipes.addLine': 'Добавить',
  'costing.recipes.recipeCost': 'Стоимость рецепта',
  'costing.recipes.dishPrice': 'Цена блюда',
  'costing.recipes.foodCost': 'Себестоимость %',
  'costing.recipes.ofPrice': '% от цены',
  'costing.recipes.profit': 'Прибыль на единицу',
  'costing.recipes.margin': '% маржа',
  'costing.recipes.unsavedChanges': 'Есть несохранённые изменения',
  'costing.recipes.discard': 'Отменить',
  'costing.recipes.save': 'Сохранить рецепт',
  'costing.recipes.saving': 'Сохранение...',
  'costing.recipes.saveError': 'Ошибка сохранения рецепта',
  'costing.recipes.loadError': 'Ошибка загрузки рецепта',

  // Помощник прибыли — Аналитика
  'costing.assistant.label': 'Помощник прибыли',
  'costing.assistant.title': 'Анализ прибыльности',
  'costing.assistant.loading': 'Загрузка...',
  'costing.assistant.refresh': 'Обновить',
  'costing.assistant.insufficientData': 'Недостаточно данных для анализа',
  'costing.assistant.revenue': 'Выручка',
  'costing.assistant.units': 'Продано единиц',
  'costing.assistant.cogs': 'Себестоимость',
  'costing.assistant.profit': 'Валовая прибыль',
  'costing.assistant.coverage': 'Покрытие расчётов',
  'costing.assistant.matrix': 'Матрица меню (BCG)',
  'costing.assistant.stars': 'Звёзды — популярно, прибыльно',
  'costing.assistant.plowhorses': 'Рабочие лошадки — популярно, низкая прибыль',
  'costing.assistant.puzzles': 'Загадки — непопулярно, прибыльно',
  'costing.assistant.dogs': 'Собаки — непопулярно, низкая прибыль',
  'costing.assistant.noItems': 'Нет позиций в этой категории',
  'costing.assistant.dishes': 'Все блюда',
  'costing.assistant.noDishes': 'Нет блюд с продажами',
  'costing.assistant.name': 'Блюдо',
  'costing.assistant.sold': 'Продано',
  'costing.assistant.cost': 'Стоимость',
  'costing.assistant.margin': 'Маржа',
  'costing.assistant.foodCost': 'Себ. %',
  'costing.assistant.recommendations': 'Рекомендации',
  'costing.assistant.loadError': 'Ошибка загрузки аналитики',
  'costing.assistant.heroTitle': 'Увеличивайте прибыль с каждого блюда',
  'costing.assistant.heroDesc': 'Смотрите реальную себестоимость, находите самые выгодные позиции и получайте рекомендации, какие блюда стоит продвигать, изменить или убрать из меню.',
  'costing.assistant.heroCta': 'Проверьте, какие блюда приносят вам деньги',
};
